import React from 'react'
import Navbar from '../inc/Navbar'
import Project from './Project'
import {Link} from "react-router-dom";

function Srgcomplex() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <br/>


      <div className='krishnagarland'>
        <div className="album py-1">
          <div className="container mt-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li style={{color:"white"}} className="breadcrumb-item"><Link to="/"  style={{color:"white"}}>Home</Link></li>
                <li style={{color:"white"}} className="breadcrumb-item active" aria-current="page">SRG Complex Project</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>      
        <Project/>
        <br/>
    </div>
  )
}

export default Srgcomplex